import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const VolumeDownIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "VolumeDown",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M19.58 2.13c-.2-.08-.42-.13-.66-.13-.49 0-.93.2-1.25.51L11.18 9H4.91c-.97 0-1.75.78-1.75 1.75v10.5c0 .97.78 1.75 1.75 1.75h6.27l6.49 6.49c.32.32.76.52 1.24.52.24 0 .47-.05.68-.14h-.01c.64-.27 1.08-.89 1.08-1.61V3.75c0-.73-.44-1.35-1.07-1.61h-.01Zm6.22 7.8c-.29-.22-.65-.35-1.05-.35-.97 0-1.75.78-1.75 1.75 0 .57.27 1.08.7 1.4.99.76 1.63 1.94 1.63 3.27s-.64 2.51-1.62 3.26h-.01c-.43.33-.7.84-.7 1.41 0 .97.78 1.75 1.75 1.75.4 0 .76-.13 1.05-.35 1.85-1.4 3.03-3.59 3.03-6.06s-1.18-4.67-3.01-6.05h-.02v-.01Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M21.29 29.29q-.3 0-.57-.15l-11.61-6.7H3c-.3 0-.59-.12-.81-.33-.21-.21-.33-.5-.33-.81V9.87c0-.63.51-1.14 1.14-1.14l6.04-.03 11.68-6.68c.35-.2.79-.2 1.14 0s.57.58.57.99v25.14c0 .41-.22.79-.57.99q-.27.15-.57.15M9.41 20.14c.2 0 .4.05.57.15l10.17 5.87V4.97L9.91 10.82c-.17.1-.36.15-.56.15l-5.2.03v9.15h5.26Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M8.71 17.86c-.63 0-1.14-.51-1.14-1.14v-2.29a1.14 1.14 0 1 1 2.28 0v2.29c0 .63-.51 1.14-1.14 1.14M25.86 20.76a1.143 1.143 0 0 1-.19-2.27c1.43-.24 2.48-1.47 2.48-2.92s-1.04-2.68-2.48-2.92a1.147 1.147 0 0 1 .38-2.26c2.54.43 4.38 2.6 4.38 5.17s-1.84 4.74-4.38 5.17c-.06.01-.13.02-.19.02Z"
      })]
    })
  }));
};
VolumeDownIcon.displayName = 'VolumeDownIcon';